document.addEventListener("click", async (e) => {
  const svg = e.target.closest("svg.quick-plus-svg");
  if (!svg) return;

  const variantId = svg.getAttribute("data-variant-id");
  if (!variantId) return;

  svg.style.pointerEvents = "none";

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    });

    const data = await res.json();
    if (data.status) throw new Error(data.description);

    const html = await fetch("/?section_id=cart-drawer-la").then(r => r.text());
    const doc = new DOMParser().parseFromString(html, "text/html");

    const newDrawer = doc.querySelector(".cart-drawer-la");
    const oldDrawer = document.querySelector(".cart-drawer-la");
    const cartBubble = document.querySelector(".cart-count-bubble-la");
    const cartCount = document.querySelector(".cart-count-header-la");

    if (cartCount && cartBubble) {
      const currentCount = parseInt(cartCount.textContent) || 0;
      const newCount = currentCount + 1;

      cartCount.textContent = newCount;

      if (newCount > 0) {
        cartBubble.classList.add("product-form-active-la");
      }
    }

    if (newDrawer && oldDrawer) {
      oldDrawer.replaceWith(newDrawer);
      newDrawer.classList.add("cart-drawer-active-la");
      document.body.style.overflow = "hidden";
    }

  } catch (err) {
    console.error("Add variant error:", err);
  } finally {
    svg.style.pointerEvents = "";
  }
});
